import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import React from 'react'

const PageFilter = ({options,width,filterValue,handleSheetFilter}) => {
  return (
    <FormControl 
        //sx={{width:`${width}%`,mb:2}} 
        fullWidth
        margin={'dense'}
    >
        <InputLabel id="demo-simple-select-standard-label">Sheet</InputLabel>
        <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            sx={{ "&:focus": {
                backgroundColor: "#ffffff"
                } 
            }}
            label="Sheet" 
            value={filterValue || ""}
            onChange={(event) => handleSheetFilter(event)}
            name="sheet"
        >
            <MenuItem value="">Select Sheet</MenuItem>
            { options?.map((option) => (
                <MenuItem key={option.value} value={option.value}>{option.name}</MenuItem>
            ))}
        </Select>
    </FormControl>
  )
}

export default PageFilter